// Angular Imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Component Imports
import { PhxActionRowComponent } from './phx-action-row.component';
import { PhxActionRowItemDirective } from './phx-action-row-item.directive';

// Module Imports
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxMenuModule } from '../menu/menu.module';
import { PhxMenuButtonModule } from '../button-menu/phx-menu-button.module';

@NgModule({
  declarations: [PhxActionRowComponent, PhxActionRowItemDirective],
  imports: [
    CommonModule,
    PhxDropdownModule,
    PhxMenuButtonModule,
    PhxMenuModule,
  ],
  exports: [PhxActionRowComponent, PhxActionRowItemDirective],
})
export class PhxActionRowModule {}
